// extracted by mini-css-extract-plugin
module.exports = {"container":"select-word-box_container___lXXH","word":"select-word-box_word__1horH","textBox":"select-word-box_textBox__3OYib","selectedWord":"select-word-box_selectedWord__15qdk"};